export enum CostPriceType {
  CURRENT = "CURRENT",
  PREVIOUS = "PREVIOUS",
}
